import type React from "react";

import { useDroppablePlaceholder } from "./context/droppable";

export const DraggablePlaceholder: React.FC = () => useDroppablePlaceholder();
